<template>
  <DsShowcase title="ToastPlay" description="Notificação temporária com ícone, título, mensagem e barra de progresso.">
    <!-- PROP: color / icon / title / message -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">color / icon / title / message</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">
        <code>color: string</code> — cor do toast.
        <code>icon: { name, type }</code> — ícone Material Symbols.
        <code>title / message: string</code>
      </p>
      <div class="tw:flex tw:gap-4 tw:flex-wrap tw:mb-6">
        <ButtonPlayV2 text="Sucesso" color="#38a169" size="sm" @click="showToast('success')" />
        <ButtonPlayV2 text="Erro" color="#e53e3e" size="sm" @click="showToast('error')" />
        <ButtonPlayV2 text="Aviso" color="#f59e0b" size="sm" @click="showToast('warning')" />
        <ButtonPlayV2 text="Info" color="#3182ce" size="sm" @click="showToast('info')" />
      </div>
      <div class="tw:space-y-3">
        <ToastPlay
          v-if="visible.success"
          title="Sucesso"
          message="Operação realizada com sucesso!"
          color="#38a169"
          :icon="{ name: 'check_circle', type: 'outlined' }"
          :duration="0"
          @close="visible.success = false"
        />
        <ToastPlay
          v-if="visible.error"
          title="Erro"
          message="Algo deu errado. Tente novamente."
          color="#e53e3e"
          :icon="{ name: 'error', type: 'outlined' }"
          :duration="0"
          @close="visible.error = false"
        />
        <ToastPlay
          v-if="visible.warning"
          title="Atenção"
          message="Sua sessão expira em 5 minutos."
          color="#f59e0b"
          :icon="{ name: 'warning', type: 'outlined' }"
          :duration="0"
          @close="visible.warning = false"
        />
        <ToastPlay
          v-if="visible.info"
          title="Informação"
          message="Nova versão disponível."
          color="#3182ce"
          :icon="{ name: 'info', type: 'outlined' }"
          :duration="0"
          @close="visible.info = false"
        />
      </div>
    </section>

    <!-- PROP: duration -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">duration</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>number</code> — tempo em ms para fechar automaticamente. <code>0</code> = não fecha. Padrão: <code>5000</code></p>
      <div class="tw:flex tw:gap-4 tw:flex-wrap">
        <ButtonPlayV2 text="Toast com 3s" size="sm" variant="outline" @click="showTimed = true" />
      </div>
      <div class="tw:mt-4">
        <ToastPlay
          v-if="showTimed"
          message="Este toast fecha em 3 segundos"
          color="#7c3aed"
          :icon="{ name: 'timer', type: 'outlined' }"
          :duration="3000"
          @close="showTimed = false"
        />
      </div>
    </section>

    <!-- Sem título -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Apenas mensagem (sem título)</h2>
      <div class="tw:space-y-3">
        <ToastPlay
          message="Arquivo salvo com sucesso"
          color="#38a169"
          :icon="{ name: 'save', type: 'outlined' }"
          :duration="0"
          @close="() => {}"
        />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { reactive, ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { ToastPlay, ButtonPlayV2 } from "@/components/atomic"


const visible = reactive({ success: true, error: true, warning: true, info: true })
const showTimed = ref(false)

function showToast(type: string) {
  visible[type as keyof typeof visible] = true
}
</script>
